import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: string;
  rating: number;
  views: number;
  updateDate: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  status,
  rating,
  views,
  updateDate,
}: ComicCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          title={`${title} - 樱花动漫91漫画全集在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium bg-primary-500/90 px-2 py-1 rounded-md whitespace-nowrap">
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-accent-500 text-white text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
          {rating}
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{author}</p>
      <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
          {formatViews(views)}
        </span>
        <span className="whitespace-nowrap">{updateDate}</span>
      </div>
    </Link>
  );
}